module.exports = __webpack_public_path__ + "fonts/Manrope-400-vietnamese4_c4999d3.woff2";